export enum TransactionType {
  Rent = 'rent',
  Buy = 'buy',
}
/**
 * Map of possible transaction categories
 */
export enum TransactionCategory {
  AddItems = 'add-items',
  AssetRecovery = 'asset-recovery',
  LateFee = 'fee',
  Miscellaneous = 'miscellaneous',
  ParentOrder = 'parent-order',
  Product = 'product',
  RentToKeep = 'rent-to-keep',
  Shipping = 'shipping',
}

/**
 * Map of possible revenue types - they are a type of line item in
 * a transaction that is not tied to charges or refunds
 */
export enum RevenueType {
  AccountBalanceCredit = 'account-balance-credit',
  AccountBalanceDebit = 'account-balance-debit',
  AssetRecovery = 'asset-recovery',
  BoxReimbursement = 'box-reimbursement',
  DryCleaningTailoring = 'dry-cleaning-tailoring',
  Insurance = 'insurance',
  LateFee = 'fee',
  Miscellaneous = 'miscellaneous',
  PromoCodeRedemption = 'promo-code-redemption',
  ParentOrder = 'parent-order',
  Product = 'product',
  RentToKeep = 'rent-to-keep',
  Shipping = 'shipping',
  TbtError = 'tbt-error',
}

export type TransactionOrderItemType = 'buy' | 'rent'

export interface TransactionOrderItem {
  id: number
  name: string
  price: number
  quantity: number
  revenueType: RevenueType
  image?: string
  transactionType?: TransactionOrderItemType
}

export interface TransactionOrder {
  id: number
  transactionItems: TransactionOrderItem[]
  wearerName: string
}

export type transactionTypeCode = 'Sale' | 'Refund'
export interface Transaction {
  accountBalanceApplied: number
  accountBalanceCredited: number
  createdOn: string
  id: string
  insuranceQuantity: number
  insuranceSubtotal: number
  orders: TransactionOrder[]
  promoCodeDiscount: number
  shippingSubtotal: number
  subtotal: number
  taxTotal: number
  total: number
  transactionType: transactionTypeCode
  transactionCategories: TransactionCategory[]
}

export interface EventTransactions {
  eventName: string
  transactions: Transaction[]
}

export interface OrderLookProduct {
  id: string
  slug: string
  name: string
  price: string
  rentPrice: string
  buyPrice: string
  photos: string[]
  category: string
  urlSlug: string
  transactionType: TransactionOrderItemType
}

export interface OrderLookItem {
  id: string
  productSetId: string
  product: OrderLookProduct
  payer: number
  transactionType: TransactionOrderItemType
}
